export default __webpack_public_path__ + "static/cLOjOtdH-196bc7efe9f9ccb12e740358f4988078.svg";